import React, { useEffect } from 'react'
import UniPay from '../../Component/UniPay/UniPay';
import './Privacy.scss'
function Privacy() {
	useEffect(() => {
		document.body.classList.add("privacybg");

		return () => {
			document.body.classList.remove("privacybg");
		};
	}, []);
	return (
		<div className='privacy container'>
			<h2>Privacy Policy</h2>
			<p className='privacy_topText'>Welcome to Universal Wallet Payment System (“we,” “our,” or “us”). Your privacy is important to us, and we are committed to protecting your personal data. This Privacy Policy outlines how we collect, use, and safeguard your information in compliance with the General Data Protection Regulation (GDPR) and other applicable laws in the European Union (EU).</p>
			<div className='privacy_inner'>
				<h4>1. Information We Collect</h4>
				<p>We collect and process the following types of personal data:</p>
				<ul className='listDisc'>
					<li><b>Personal Identification Information:</b> Name, email address, phone number, address, date of birth.</li>
					<li><b>Account Information:</b> Login credentials, payment information, and account preferences.</li>
					<li><b>Account Information:</b> Login credentials, payment information, and account preferences.</li>
					<li><b>KYC Information:</b> Documents required for identity verification.</li>
					<li><b>Device Information:</b> IP address, browser type, and device details.</li>
					<li><b>Usage Data:</b> How you interact with our website, including pages viewed, time spent, and clicks.</li>
				</ul>
			</div>
			<div className='privacy_inner'>
				<h4>2. How We Use Your Information</h4>
				<p>We use your personal data for the following purposes:</p>
				<ul className='listDecimal'>
					<li><b>Service Delivery:</b>To provide, manage, and improve our services.</li>
					<li><b>Account Management: </b>To create and manage your account.</li>
					<li><b>Compliance:</b>  To comply with legal and regulatory requirements, including KYC and AML obligations. </li>
					<li><b>Communication:</b>  To send notifications, updates, and respond to inquiries. </li>
					<li><b>Analytics:</b> To analyze usage trends and improve our platform. </li>
					<li><b>Marketing:</b> To send promotional materials (with your consent).</li>
				</ul>
			</div>
			<div className='privacy_inner'>
				<h4>3. Legal Basis for Processing</h4>
				<p>We process your data based on:</p>
				<ul className='listDisc'>
					<li><b>Consent:</b>  Where you have provided clear consent. </li>
					<li><b>Contractual Necessity:</b>To fulfill our obligations to you. </li>
					<li><b> Legal Obligations:</b> To comply with laws and regulations. </li>
					<li><b> Legitimate Interests:</b> For operational efficiency and fraud prevention</li>
				</ul>
			</div>
			<div className='privacy_inner'>
				<h4>4. Data Sharing</h4>
				<p>We do not sell or rent your personal data to third parties. However, we may share your data with:</p>
				<ul className='listDisc'>
					<li><b> Service Providers:</b> Third-party vendors for hosting, payment processing, or KYC verification.  </li>
					<li><b>Compliance Authorities:</b> To meet legal obligations.  </li>
					<li><b> Business Partners:</b>  With consent, for joint marketing initiatives.</li>
				</ul>
			</div>
			<div className='privacy_inner'>
				<h4>5. Data Retention</h4>
				<p style={{ paddingBottom: '15px', fontWeight: '300' }}>We retain your personal data only as long as necessary for the purposes outlined in this Privacy Policy or as required by law. Once no longer needed, your data will be securely deleted.</p>
			</div>
			<div className='privacy_inner'>
				<h4>6. Your Rights</h4>
				<p>Under <b>GDPR</b>, you have the following rights:</p>
				<ul className='listDisc'>
					<li><b> Access:</b>  Request a copy of your personal data.  </li>
					<li><b> Rectification:</b> Correct inaccurate or incomplete data.  </li>
					<li><b> Erasure:</b> Request deletion of your data (“Right to be forgotten”). </li>
					<li><b> Restriction:</b> Limit the processing of your data. </li>
					<li><b>Data Portability:</b> Request transfer of your data to another platform. </li>
					<li><b>Objection:</b> Object to processing based on legitimate interests. </li>
					<li><b>Withdraw Consent:</b> Withdraw consent at any time (for processing based on consent).</li>
				</ul>
				<p style={{ paddingBottom: '15px', fontWeight: '300' }}>To exercise these rights, contact us at <i style={{ fontWeight: 700, color: '#FFE8C0' }}>info@uniwalletpay.com.</i></p>
			</div>
			<div className='privacy_inner'>
				<h4>7. Data Security</h4>
				<p style={{ paddingBottom: '15px', fontWeight: '300' }}>We implement robust technical and organizational measures to protect your data against unauthorized access, disclosure, or loss.</p>
			</div>
			<div className='privacy_inner'>
				<h4>8. Data Security</h4>
				<p style={{ paddingBottom: '15px', fontWeight: '300' }}>If we transfer your data outside the EU, we ensure adequate protection through standard contractual clauses or equivalent safeguards.</p>
			</div>
			<div className='privacy_inner'>
				<h4>9. Cookies and Tracking Technologies</h4>
				<p style={{ paddingBottom: '15px', fontWeight: '300' }}>We use cookies to enhance your experience. You can manage cookie preferences through your browser settings. For more details, refer to our [Cookie Policy] (link if applicable).</p>
			</div>
			<div className='privacy_inner'>
				<h4>10. Changes to This Policy</h4>
				<p style={{ paddingBottom: '15px', fontWeight: '300' }}>We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised effective date</p>
			</div>
			<div className='privacy_inner'>
				<h4>11. Contact Us</h4>
				<p style={{ paddingBottom: '15px' }}>If you have questions or concerns about this Privacy Policy or your personal data, please contact us at:</p>
				<p style={{ paddingBottom: '15px' }}>Email: <i style={{ fontWeight: 700, color: '#FFE8C0' }}>info@uniwalletpay.com</i></p>
				<p style={{ paddingBottom: '15px', fontWeight: '300' }}>By using our website, you consent to the terms of this Privacy Policy</p>
				<UniPay />
			</div>
		</div>
	)
}

export default Privacy